<template>
  <v-expansion-panel style="border-radius: 6px">
    <v-expansion-panel-header
      style="font-weight: 600; color: #746b6b; font-size: 12x"
    >
      {{ $t("events.event-config.products-and-recharges") }}
    </v-expansion-panel-header>
    <v-expansion-panel-content class="py-6">
      <v-row>
        <v-col cols="12">
          <BaseSelect
            :label="$t('events.event-config.add-products-and-recharges')"
            :placeholder="$t('events.event-config.link-events')"
            item-text="descricao"
            return-object
            small-chips
            multiple
            item-color="tertiary"
            :clearable="false"
            :items="linkedEventsList"
            v-model="currentLinked"
            @change="changeLinkedEvents"
          />
        </v-col>
      </v-row>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mixins from "@/mixins";
import BaseSelect from "@/components/forms/BaseSelect.vue";

export default {
  name: "LinkedEvents",
  mixins: [mixins],
  components: {
    BaseSelect,
  },
  data() {
    return {
      currentLinked: [],
      options5: {
        locale: "pt-BR",
        suffix: "UTC-3",
      },
    };
  },
  watch: {
    "$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento"(e) {
      if (e == 0) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 24;
      }
      if (e == 1) {
        this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra = 7;

        this.$produtos_gerenciar.cadastro.dados_cadastrais.horas_canc_antes_evento = 24;
      }
    },
    linkedEventsList: {
      handler: function (newVal) {
        this.updateLinkedEvents(newVal, this.linkedEvents);
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["linkedEventsList", "linkedEvents", "hasLinkedEvents"]),
  },
  methods: {
    ...mapActions(["setHasLinkedEvents", "setLinkedEvents"]),

    updateLinkedEvents(newVal, value) {
      const values = [];
      if (Array.isArray(value)) {
        value.forEach(item => {
          newVal.forEach(item2 => {
            if (item === item2.idproduto || item === item2.idcombo) {
              values.push(item2);
            }
          });
        });
      } else {
        value.nidvinculados?.forEach(item => {
          newVal.forEach(item2 => {
            if (item === item2.idproduto || item === item2.idcombo) {
              values.push(item2);
            }
          });
        });
      }
      this.currentLinked = values;
    },
    changeLinkedEvents(value) {
      const ids = {
        nidvinculados: [],
      };

      if (value?.length > 0) {
        value.forEach(item => {
          ids.nidvinculados.push(item.idproduto || item.idcombo);
        });
      } else {
        this.currentLinked = [];
      }

      this.setLinkedEvents(ids);
    },
  },
  created() {
    if (
      this.$produtos_gerenciar.cadastro.dados_cadastrais.dias_canc_apos_compra >
      7
    ) {
      this.$produtos_gerenciar.cadastro.dados_cadastrais.controla_cancelamento = 2;
    }
  },
  destroyed() {
    this.setHasLinkedEvents(false);
    this.setLinkedEvents({ nidvinculados: [] });
    this.currentLinked = [];
  },
};
</script>

<style>
.active-class {
  background-color: #e6f7ff !important;
  border-color: #91d5ff !important;
  color: #1890ff !important;
}
</style>
